import React from 'react'
import { Link } from '@mui/material'
import { isArray, isEmpty, filter } from 'lodash'
import { StackTable } from '../../'
import { useAcademicDataDigest } from '../../../local'
import './CourseSectionsList.scss'

/**
 * @typedef {import('../../../definitions').CourseSectionExpRecord} CourseSectionExpRecord
 */

/**
 * @typedef {Object} CourseSectionsListProps
 * @property {string} sectionViewBasePath Section detail page base URL path
 * @property {CourseSectionExpRecord[]} courseSections Course sections collection
 */

/**
 * Course section list.
 * @param {CourseSectionsListProps} props
 * @return {JSX.Element}
 */
const CourseSectionsList = ({ courseSections, sectionViewBasePath }) => {
  const { composeSectionComponentsTableData } = useAcademicDataDigest()
  const isStorybook = `${process.env.STORYBOOK}` === 'yes'

  if (!courseSections) {
    return null
  }

  /**
   * Handle click on course section.
   * @param {React.MouseEvent<HTMLAnchorElement>} e
   */
  const handleSectionClick = (e) => {
    // Prevent opening target link when running in SB.
    if (isStorybook) {
      e.preventDefault()
      alert('Course section detail route will open when running in Drupal.')
    }
  }

  const courseSectionsTables = filter(
    courseSections.map((courseSection) => {
      const courseSectionTable = composeSectionComponentsTableData(courseSection)
      const courseSubjectCode = courseSection.course?.courseSubject?.code || ''
      const courseNumber = courseSection.course?.courseNumber || ''
      const courseCode = escape(`${courseSubjectCode} ${courseNumber}`)
      const courseSectionId = courseSection.courseSectionId || 'unknown'
      return courseSectionTable.map((item) => {
        if (item.field === 'section') {
          return {
            ...item,
            value: (
              <Link
                onClick={handleSectionClick}
                href={`${sectionViewBasePath}/${courseCode}/${courseSectionId}`}
              >
                {item.value}
              </Link>
            ),
          }
        }

        return item
      }, [])
    })
  )

  if (!isArray(courseSectionsTables) || isEmpty(courseSectionsTables)) {
    return null
  }

  return (
    <>
      {courseSectionsTables.map((tableFields, tableIndex) => (
        <div className="course-sections-box" key={tableIndex}>
          <StackTable tableFields={tableFields} />
        </div>
      ))}
    </>
  )
}

export default CourseSectionsList
